<template>
  <div id="private">
    <navigation-bar id="navigation-bar"></navigation-bar>
    <div class="container container-top">
      <div class="row">
        <router-view v-slot="{ Component, route }">
          <transition name="fade" mode="out-in">
            <div :key="route.path" class="route-wrapper">
              <component :is="Component" />
            </div>
          </transition>
        </router-view>
      </div>
    </div>
    <footer-bar></footer-bar>
    <!-- Mobile Message Widget - only shown when logged in -->
    <mobile-message-widget />
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import NavigationBar from "./private-layouts/navigation/NavigationBar";
import FooterBar from "./private-layouts/FooterBar";
import MobileMessageWidget from "./private-layouts/message/MobileMessageWidget";
import { useHelpContentStore } from "@/stores/helpContentStore";
import { useOrganizationStore } from "@/stores/organizationStore";

export default {
  name: "private-layout",
  components: {
    FooterBar,
    NavigationBar,
    MobileMessageWidget,
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    accountnumber() {
      return this.allData?.manager?.externid2 || this.allData?.patient?.externId2 || "";
    },
  },
  mounted() {
    this.preloadHelpCaches(this.accountnumber);
  },
  watch: {
    accountnumber(next) {
      if (next) this.preloadHelpCaches(next);
      else useOrganizationStore().clear();
    },
  },
  methods: {
    /** Warm org name + help article caches for the session. */
    preloadHelpCaches(accountnumber) {
      if (!accountnumber) return;
      useOrganizationStore().ensureLoaded(accountnumber);
      useHelpContentStore().ensureLoaded(accountnumber);
    },
  },
}
</script>

<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  /* Fallthrough id lives on NavigationBar's root; pierce scoped styles with :deep. */
  :deep(#navigation-bar) {
    position: sticky;
    top: 0;
    z-index: 100;
  }
  @media (max-width: 576px) {
    /* Above HelpModal (.help-shell at 2000100) so the hamburger stays usable. */
    :deep(#navigation-bar) {
      position: sticky;
      top: 0;
      z-index: 2000500;
    }
  }
  .route-wrapper {
    max-width: 100%;
    min-width: 0;
  }
  @media (max-width: 576px) {
    /*
     * overflow-x: hidden on #private breaks position:sticky for the mobile
     * header (it becomes a scroll container). Use clip so wide children are
     * still clipped without killing sticky.
     */
    #private {
      overflow-x: clip;
      max-width: 100vw;
    }
    .container-top {
      max-width: 100%;
      overflow-x: hidden;
    }
    .route-wrapper {
      overflow-x: hidden;
    }
  }
</style>